import { IconSun, IconMoon } from '@tabler/icons-react';
import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';

export const ThemeToggle = () => {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return (
      <div className="w-9 h-9 rounded-[12px] border-[0.5px] border-[color:hsl(var(--hairline))]" />
    );
  }

  return (
    <button
      onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
      className="p-2 rounded-[12px] border-[0.5px] border-[color:hsl(var(--hairline))] hover:border-[color:hsl(var(--brand-orange))] transition-[border-color] duration-200 ease-out"
      data-testid="theme-toggle"
      aria-label="Toggle theme"
    >
      {theme === 'dark' ? (
        <IconSun size={18} stroke={1.75} className="text-[color:hsl(var(--brand-orange))]" />
      ) : (
        <IconMoon size={18} stroke={1.75} className="text-[color:hsl(var(--brand-charcoal))]" />
      )}
    </button>
  );
};